import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'

import './styles.scss'

const Placeholder = ({ position = -1, app = AppModelNULL }) => {
  const visible = position > -1 ? 'visible' : ''
  const { formatMessage } = app

  return (
    <div className={`placeholder ${visible}`} style={{ top: position + 'px' }}>
      <div className="placeholder-line">
        <div className="placeholder-text">
          {formatMessage('placeholder.placeholder')}
        </div>
      </div>
    </div>
  )
}

Placeholder.propTypes = {
  position: PropTypes.number,
  app: PropTypes.instanceOf(AppModel),
}

export default inject('app')(observer(Placeholder))
